import {apiAuth} from '@/api/fetch'

const apiGetFloatingMenuInfo = async (org, container_id) => {
    const params = {
        org,
        container_id,
    }
    const res = await apiAuth('GET', '/globalsite/floatingmenu', params)
    if (res.status === 200) {
        return res.data.data[0]
    }
}

const apiCreateFloatingMenu = async (org, container_id, config) => {
    const params = {
        org,
    }
    const payload = {
        memo: '',
        activate: false,
        container_id: container_id,
        add_column: config,
        preview_url: '',
    }
    const res = await apiAuth('POST', '/globalsite/floatingmenu', { params, payload })
    return res.status === 200
}

const apiEditFloatingMenu = async (org, config) => {
    const params = {
        org,
    }
    const payload = {}
    for (const [key, value] of Object.entries(config)) {
        payload[key] = value
    }

    const res = await apiAuth('PATCH', '/globalsite/floatingmenu', { params, payload })
    return res.status === 200
}

const apiGetDemoImg = async (org, container) => {
    const params = {
        org,
        container,
    }
    const res = await apiAuth('GET', '/container/screenshot', params)
    if (res.status === 200) {
        return res.data.data.metaData
    }
}

export {
    apiGetFloatingMenuInfo,
    apiCreateFloatingMenu,
    apiEditFloatingMenu,
    apiGetDemoImg,
}